export const ITEMS_PER_PAGE = 12;
export const REDUX_STORAGE_KEY = '__REDUX_STORAGE';
export const CAN_USE_DOM = typeof window !== 'undefined';
export enum ROLE {
  CONTENT_VIEWER = 'CONTENT_VIEWER',
  CONTENT_EDITOR = 'CONTENT_EDITOR',
  CONTENT_ADMIN = 'CONTENT_ADMIN',
  PRODUCT_ADMIN = 'PRODUCT_ADMIN',
  DEVELOPER = 'DEVELOPER',
}
export const CSRF_TOKEN = '__ibrakadabra';
export const SESSION = '__session';
export const EMPTY_OBJ = {};
export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
export const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
